module.exports = __webpack_public_path__ + "account/assets/no-image.cbdf67eb.svg";